import type { Address } from './address-lookup.types'

const googleToGSCountryNameMap: Record<string, string> = {
  'United States': 'United States of America',
}

export function parseAddressFromComponents(
  components: google.maps.places.PlaceResult['address_components']
): Address {
  const result = {
    addressLineOne: [] as string[],
    addressLineTwo: [] as string[],
    city: undefined as string | undefined,
    country: undefined as string | undefined,
    zipCode: undefined as string | undefined,
  }

  if (!components) {
    return {
      ...result,
      addressLineOne:
        result.addressLineOne.length > 0
          ? result.addressLineOne.join(', ').trim()
          : undefined,
      addressLineTwo:
        result.addressLineTwo.length > 0
          ? result.addressLineTwo.join(', ').trim()
          : undefined,
    }
  }

  components.forEach((component) => {
    component.types.forEach((type) => {
      if (type === 'subpremise') {
        result.addressLineTwo.push(component.long_name)
      }

      if (type === 'street_number') {
        result.addressLineOne.push(component.long_name)
      }

      if (type === 'route') {
        result.addressLineOne.push(component.long_name)
      }

      if (
        ['neighborhood', 'sublocality', 'sublocality_level_2'].includes(type)
      ) {
        result.addressLineOne.push(component.long_name)
      }

      if (['locality', 'postal_town'].includes(type)) {
        if (!result.city) {
          result.city = component.long_name
        }
      }

      if (type === 'country') {
        result.country =
          googleToGSCountryNameMap[component.long_name] ?? component.long_name
      }

      if (['postal_code', 'postal_code_prefix'].includes(type)) {
        if (!result.zipCode) {
          result.zipCode = component.long_name
        }
      }
    })
  })

  return {
    ...result,
    addressLineOne:
      result.addressLineOne.length > 0
        ? result.addressLineOne.join(', ').trim()
        : undefined,
    addressLineTwo:
      result.addressLineTwo.length > 0
        ? result.addressLineTwo.join(', ').trim()
        : undefined,
  }
}
